export const ROOT_FILTER_KEYS = { 'cat': 1, 'price': 1, 'rating': 1};